import { Navigate } from "react-router-dom";

import { STILLSTAND_LIST_HREF } from "@/lib/projectsListHref";

// ---------------------------------------------------------------------------
// NAV-3 — /pipeline ist aufgeloest: die Seite zeigte dieselben Projekte wie
// /projekte, nur nach Stillstand sortiert, und stand in keiner Rollen-Leiste
// (erreichbar allein ueber zwei Links im CEO-Cockpit). Muster wie W12-3
// (/leads → /projekte?phase=neu): die Route bleibt, damit Lesezeichen und
// alte Links nicht brechen, und landet in der EINEN Arbeitsliste — Reiter
// Verkauf, Sortierung «Stillstand (laengster zuerst)», Firmensicht.
// ---------------------------------------------------------------------------

export function PipelineRedirect() {
  return <Navigate to={STILLSTAND_LIST_HREF} replace />;
}
